export enum ScreenType {
  DESKTOP = "desktop",
  MOBILE = "mobile",
}
